import { createContext as t, useContext as e } from "react";
const o = t({}), s = () => e(o);
export {
  o as TabsContext,
  s as useTabsContext
};
